import { fetch } from '@atlassian/eoc-fetch';
import { urls } from '../../constants';
const getTimezones = async () => {
  const response = await fetch(urls.customers.timezones.url());

  // NOTE: convert offset from minutes to millis
  const adjusted = response.timezones.map(timezone => ({
    ...timezone,
    offset: timezone.offset * 60000
  }));
  return {
    ...response,
    timezones: adjusted
  };
};
export const endpoints = {
  getTimezones
};